import React, { Component } from 'react';
import styles from './replyOptions.module.scss';
import PropTypes from 'prop-types';
import FlatButton from '../../../UiComponents/FlatButton';
import RaisedButton from '../../../UiComponents/RaisedButton';
import getLabel from './../../../../utils/labels'
import replyIcon from '../../../../globals/images/reply.svg';
import replyAllIcon from '../../../../globals/images/replyAll.svg';
import forwardIcon from '../../../../globals/images/forward.svg';
import { mailSequence } from './../../../../constants/tutorialSequence'


class ReplyOptions extends Component {

    onReplyClick = () => {
        //If in tutorial mode, set new steps- for inside mail
        if (this.props.tutorial && this.props.tutorial.isRunning) {
            this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
            this.props.stopTutorial();
            setTimeout(() => {
                this.props.startTutorial()
            }, 200);
        }
    }

    render() {
        const { match } = this.props;
        return <div className={styles.container}>
            <FlatButton
                className="reply-button-tutorial"
                to={`${match.url}/reply`}
                key={0}
                imageUrl={replyIcon}
                onReplyClick={this.onReplyClick}
            >
                <div>{getLabel('label_reply_button')}</div>
            </FlatButton>
            <FlatButton
                to={`${match.url}/replyall`}
                key={1}
                imageUrl={replyAllIcon}
                iconWidth='15px'
            >
                <div>{getLabel('label_reply_all_button')}</div>
            </FlatButton>
            {/* <FlatButton to={`${match.url}/forward`} key={2} imageUrl={forwardIcon}> Forward</FlatButton> */}
        </div>;

    }
}

ReplyOptions.propTypes = {

};

ReplyOptions.defaultProps = {

}

export default ReplyOptions;



// WEBPACK FOOTER //
// /src/components/mailThread/mail/replyOptions/ReplyOptions.js